import React from 'react';
import { WhatsAppOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';

const VerifiedWhatsappNotification = ({ passport }) => {
  const showNotificationModal = () => {
    Modal.success({
      title: "Hasil Persetujuan Personel",
      content: (
        <div>
          Silakan kirimkan notifikasi ke {passport.vendor.name} melalui Whatsapp.
        </div>
      ),
      okText: "Kirimkan Notifikasi",
      okCancel:true,
      onOk() {
        //redirect to wa.me, then reload the detail page
        window.open(passport.whatsapp.result.url, '_blank');
        if (window.reloadDetail) {
          window.reloadDetail();
        }
      }
    });
  }

  return (
    <Button type="primary" ghost icon={<WhatsAppOutlined />} onClick={()=>showNotificationModal()}>Kirim Notifikasi Hasil Persetujuan</Button>
  );
}

export default VerifiedWhatsappNotification;